import { Transaction } from "slotworks/services/transaction/transaction";
import Contract from "slotworks/utils/contracts/contract";

export class AgsTransaction extends Transaction {
    public setWinnings(currentWin: number, totalWin?: number, tickTime: number = 0): Contract<void> {
        return super.setWinnings(currentWin, totalWin, tickTime);
    }

    public setBalance(value: number) {
        super.setBalance(value);
    }
}
